import FormModal from './formModal'
import AlertModal from './alertModal'
import ajax from 'aria-viewer/utils/ajax'
import ModalTypes from '../constants/ModalTypes'

export default {
    modals: {
        [ModalTypes.FORM]: FormModal,
        [ModalTypes.ALERT]: AlertModal,
    },
    actions: {
        submitForm: form => {
            const { url, fields } = form
            return ajax.post(url, fields).then(({ data: { success, message } }) => {
                if (success) {
                    return { success, message }
                } else {
                    // if message existed, we can assume message is
                    // in the format of {object: key: [{'error'}],
                    // otherwise, we have no idea
                    if (message) {
                        const errors = {}
                        Object.keys(message).forEach(key => {
                            errors[key] = message[key][0]
                        })

                        return { success: false, errors }
                    } else {
                        // if message wasn't defined, we don't
                        // know what happened on the server
                        return {
                            success: false,
                            errors: {
                                error: 'Unknown server issue. ' + 'Could not process your request.',
                            },
                        }
                    }
                }
            })
        },
        closeModal: 'closeModal',
    },
}
